export const state = {
  changeThumbnailPhotograph: '',
  messageHistory: {
    id: '',
    userId: '',
    familyName: '',
    name: '',
    pronunciation: '',
    job: '',
    thumbnailPhotograph: '',
    adminUserName: '',
    phoneNumber: '',
    sendDateTime: '',
    message: ''
  },
  messageHistories: [],
  fileDownloadErrorFlg: false,
  total: 0
}
export const mutations = {
  setMessageHistory(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
      state.total = 0
    }
    const dataList = response.data['data'].map(data => ({
      ...data,
      message: convertMessage(data.message)
    }))
    state.messageHistories = dataList
    state.total = response.data['header']['total']
  },
  setDetail(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = ''
    }
    state.messageHistory = response.data['data']
  },
  async fileDownload(state, response) {
    var reader = new FileReader()
    await reader.readAsDataURL(response.data)
    reader.onloadend = () => {
      state.changeThumbnailPhotograph = reader.result
    }
  },
  fileDownloadErrorFlg(state, payload) {
    state.fileDownloadErrorFlg = payload
  }
}
function convertMessage(message) {
  if (!message || typeof message !== 'string') {
    return message
  }
  message = message.replace(/^\(|\)$/g, '')
  if (!message.includes('\n')) {
    return message
  }
  message = message.trim()
  message = message.split(/\n+/)[0]
  return message + '...'
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/messageHistoryModules/messageHistoryMutation.js